import { wait, toError, getRetryDelay } from './retry';

const MAX_RETRIES = 3;
const RETRY_DELAY_MS = 1000;

export async function loadModuleWithRetry<T>(
  loader: () => Promise<{ default: T }>,
  getError: () => Error
): Promise<T> {
  let lastError: Error | null = null;

  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    try {
      const module = await loader();

      if (!module || !module.default) {
        throw getError();
      }

      return module.default;
    } catch (e) {
      lastError = toError(e);

      if (attempt < MAX_RETRIES) {
        await wait(getRetryDelay(RETRY_DELAY_MS, attempt));
      }
    }
  }

  throw lastError || getError();
}
